import styled from 'styled-components';
import { mediaQueries, NUM_GRID_BREAKPOINT_LARGE } from 'developer-docs-shared-components/utils/mediaQueries';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import { useMetadata } from 'developer-docs-shared-components/hooks/useMetadata';
import { useScrollHashIntoView } from 'developer-docs-shared-components/hooks/useScrollHashIntoView';
import I18n from 'I18n';
import { MAIN_CONTENT_ID } from '../config/accessibility';
import DocFeedback from './DocFeedback';
import DocsBreadcrumbs from './DocsBreadcrumbs';
import Sidebar from './Sidebar';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledGrid = styled(UIGrid).withConfig({
  displayName: "DocsContent__StyledGrid",
  componentId: "sc-1nzqri2-0"
})(["max-width:1600px;&&{margin:0 auto;}", "{flex-direction:column-reverse;}"], mediaQueries.belowWidth(NUM_GRID_BREAKPOINT_LARGE));
export default function DocsContent({
  ctxKey,
  isNonStandardDoc = false,
  mdx
}) {
  // If there are named exports as well, *.default needs to be used
  const Doc = (mdx === null || mdx === void 0 ? void 0 : mdx.default) || mdx;
  const parts = (mdx === null || mdx === void 0 ? void 0 : mdx.breadcrumbs) || ctxKey.split('/');
  const breadcrumbs = parts.reduce((acc, part, i) => {
    // TODO: Not localization-compatible currently. Copied logic from https://git.hubteam.com/HubSpot/developer-docs-ui/blob/f0d0ce75b56fce23ef7dc10dc54f5b21c0173fe1/developer-docs-ui/static/js/components/DocsBreadcrumbs.tsx#L28-L42
    if (!part.startsWith('.') && !part.endsWith('.mdx')) {
      acc.push({
        name: `${part.charAt(0).toUpperCase()}${part.slice(1).replace('-', ' ')}`
      });
    }
    if (i === parts.length - 1) {
      // Add current page title
      acc.push({
        name: mdx === null || mdx === void 0 ? void 0 : mdx.title
      });
    }
    return acc;
  }, [{
    /**
     * Initial Resources parent menu item to MDX breadcrumbs
     * TODO: Localize
     */
    name: 'Resources'
  }]);

  /** Set metadata for SEO */
  const titleParams = ['developer-docs-ui.htmlTitles.mdxDoc', {
    pageTopic: (mdx === null || mdx === void 0 ? void 0 : mdx.title) || ''
  }];
  useMetadata({
    title: I18n.text(...titleParams),
    description: mdx === null || mdx === void 0 ? void 0 : mdx.metaDescription,
    noIndex: mdx === null || mdx === void 0 ? void 0 : mdx.noIndex,
    isContentLoaded: !!mdx
  });
  useScrollHashIntoView(MAIN_CONTENT_ID, !!mdx);
  if (!mdx) {
    /* There is a split second when the mdx is not loaded yet if you switch from an openapi spec
    to an mdx doc in the version switcher. */
    return /*#__PURE__*/_jsx(_Fragment, {});
  }
  return /*#__PURE__*/_jsxs(StyledGrid, {
    "data-test-id": "docs-content",
    children: [/*#__PURE__*/_jsxs(UIGridItem, {
      size: {
        xs: 12,
        md: 12,
        lg: isNonStandardDoc ? 12 : 8,
        xl: isNonStandardDoc ? 12 : 9
      }
      // Override UIGridItem default padding so left is aligned with header in legacy docs
      ,
      className: isNonStandardDoc ? 'p-x-0' : '',
      children: [!isNonStandardDoc && /*#__PURE__*/_jsx(DocsBreadcrumbs, {
        breadcrumbs: breadcrumbs
      }), /*#__PURE__*/_jsx(Doc, {}), !isNonStandardDoc && /*#__PURE__*/_jsx(DocFeedback, {
        title: mdx.title,
        pageId: mdx.pageId
      })]
    }), !isNonStandardDoc && /*#__PURE__*/_jsx(UIGridItem, {
      size: {
        xs: 12,
        md: 12,
        lg: 4,
        xl: 3
      },
      children: /*#__PURE__*/_jsx(Sidebar, {
        toc: mdx.toc,
        resources: mdx.resources
      })
    })]
  });
}